const cbs = [];

export const addLoginHandlers = function() {
    const args = Array.prototype.slice.call(arguments);
    cbs.push(
        ...args.reduce((acc, item) => {
            if (Array.isArray(item)) {
                acc.push(...item);
            } else {
                acc.push(item);
            }
            return acc;
        }, [])
    );
};

export const fireLoginHandlers = function(arg) {
    cbs.forEach(func => func(arg));
};

export const getLoginHandlers = function() {
    return [...cbs];
};

export const dumpHandlers = function() {
    cbs.length = 0;
};

const RESET_UPDATE_USER_STATE = 'resetUpdateUserState';
const FORCE_FAVORITE_REFETCH = 'forceFavoriteRefetch';

const namedHandlers = {
    [RESET_UPDATE_USER_STATE]: () => null,
    [FORCE_FAVORITE_REFETCH]: [],
};

export const initResetUpdateUserState = fn => {
    namedHandlers[RESET_UPDATE_USER_STATE] = fn;
};

export const resetUpdateUserState = () => {
    if (typeof namedHandlers[RESET_UPDATE_USER_STATE] === 'function') {
        namedHandlers[RESET_UPDATE_USER_STATE]();
    }
};

export const addForceFavoriteRefetchHandler = fn => {
    namedHandlers[FORCE_FAVORITE_REFETCH] = [fn, ...namedHandlers[FORCE_FAVORITE_REFETCH]];
};

export const fireForceFavoriteRefetchHandlers = () => {
    namedHandlers[FORCE_FAVORITE_REFETCH].forEach(fn => {
        if (typeof fn === 'function') {
            fn();
        }
    });
};
